export default __webpack_public_path__ + "static/media/icon-lockCB.6b4d0685.svg";